import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

import Image from '../../image/Image';

const planFeatureMobile = media.phone`
    font-size: 12px;
    line-height: 1.83;
    padding: 5px 0 5px 30px;
`;

const iconMobile = media.phone`
    top: 10px;
`;

export const Icon = styled(Image)`
  position: absolute;
  left: 0;
  top: 8px;
  ${iconMobile};
`;

export const PlanFeatureText = styled.span``;
export const Rows = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const Columns = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const ContentContainer = styled.div``;
export const PlanFeatureDescription = styled.div`
  font-weight: 400;
  font-size: 11px;
  line-height: 20px;
  color: #8b9499;
`;
export const IconsContainer = styled.div`
  display: flex;
`;

export const PlanFeatureWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: left;
  width: 100%;
  padding: 4px 0 5px 30px;
  position: relative;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  align-items: baseline;
  ${planFeatureMobile};
`;
